import { mapGetters, mapMutations } from 'vuex';
import IconArrowNextDark from '@/components/icons/IconArrowNextDark.vue';
import IconArrowPrevDark from '@/components/icons/IconArrowPrevDark.vue';
import Empty from '@/components/@general/Empty/index.vue';
import ImageHoverZoom from '@/components/@general/ImageHoverZoom/index.vue';

export default {
  name: 'ZoomModal',
  components: { ImageHoverZoom, Empty, IconArrowPrevDark, IconArrowNextDark },

  data() {
    return {
      product: null,
      slides: [],
      activeIndex: 0,
      activeThumbIndex: 0,
      mainCardWidth: 0,

      maxVisibleThumbs: 4,
      btnsHeight: 112,
      thumbCardHeight: 52,
      thumbGap: 8,

      isVideoEnded: true,

      isScrolling: false,
      scrollTimeout: null,

      touchStartX: 0,
      touchEndX: 0,
      swipeThreshold: 50
    };
  },

  created() {
    let sliderData = this.modalData['zoomModal'] || null;

    console.log('sliderData', sliderData);

    if (sliderData.data) this.product = sliderData.data;
    if (sliderData?.slides) {
      let index = sliderData.activeIndex || 0;
      this.activeIndex = index;
      this.activeThumbIndex = index;
      this.slides = sliderData.slides;
    }
  },

  mounted() {
    this.$nextTick(() => {
      this._updateSizes();

      let sliderMain = this.$refs.zmSliderMain;
      if (sliderMain) {
        sliderMain.addEventListener('wheel', this._mouseScroll, { passive: false });

        sliderMain.addEventListener('touchstart', this._touchStart, { passive: true });
        sliderMain.addEventListener('touchmove', this._touchMove, { passive: true });
        sliderMain.addEventListener('touchend', this._touchEnd, { passive: true });
      }
    });
  },

  watch: {
    appSize: function () {
      this._updateSizes();
    },
    activeIndex(newVal, oldVal) {
      if (this.slides[oldVal] && this.slides[oldVal].type === 'video') {
        this.onPauseVideo();
      }

      if (this.slides[newVal] && this.slides[newVal].type === 'video') {
        this.isVideoEnded = true;
      }
    }
  },

  computed: {
    ...mapGetters({
      modalData: 'app/modalData',
      appSize: 'app/size'
    }),

    thumbsWindowHeight() {
      let visibleCount = Math.min(this.slides.length, this.maxVisibleThumbs);
      if (visibleCount <= 0) return 0;
      return this.thumbCardHeight * visibleCount + this.thumbGap * (visibleCount - 1);
    },

    thumbSliderStyle() {
      let translateY = 0;
      let totalSlides = this.slides.length;
      let itemFullHeight = this.thumbCardHeight + this.thumbGap;

      if (totalSlides > this.maxVisibleThumbs) {
        let currentVisiblePageStart = Math.floor(this.activeThumbIndex / this.maxVisibleThumbs) * this.maxVisibleThumbs;

        translateY = currentVisiblePageStart * itemFullHeight;

        let maxTranslateY = (totalSlides - this.maxVisibleThumbs) * itemFullHeight;

        if (translateY > maxTranslateY) {
          translateY = maxTranslateY;
        }
      }

      return {
        transform: `translateY(-${translateY}px)`,
        transition: 'transform 0.3s ease-in-out'
      };
    },

    isShowThumbsBtn() {
      return this.slides.length > this.maxVisibleThumbs;
    },

    mainSliderStyle() {
      return {
        width: `${this.slides.length * this.mainCardWidth}px`,
        transform: `translateX(-${this.activeIndex * this.mainCardWidth}px)`,
        transition: 'transform 0.3s ease-in-out'
      };
    }
  },

  methods: {
    ...mapMutations({
      modalClose: `app/MODAL_CLOSE`
    }),

    _updateSizes() {
      this.$nextTick(() => {
        if (this.$refs.zmSlider) {
          let height = this.$refs.zmSlider.offsetHeight;
          this.maxVisibleThumbs = Math.floor((height - this.btnsHeight) / (this.thumbCardHeight + this.thumbGap));
        }

        if (this.$refs.zmSliderMain) {
          this.mainCardWidth = this.$refs.zmSliderMain.offsetWidth;
        }
      });
    },

    onChangeThumbs(direction) {
      let offset = this.maxVisibleThumbs;
      let newIndex = this.activeIndex;
      let totalSlides = this.slides.length;
      let maxIndex = totalSlides - 1;

      if (direction === 'prev') {
        let currentBlockStart = Math.floor(newIndex / offset) * offset;

        newIndex = currentBlockStart - offset;

        if (newIndex < 0) {
          newIndex = 0;
        }
      } else if (direction === 'next') {
        newIndex = Math.floor(newIndex / offset) * offset + offset;

        if (newIndex >= totalSlides) {
          let lastBlockStart = Math.floor(maxIndex / offset) * offset;
          newIndex = lastBlockStart;

          if (this.activeThumbIndex === lastBlockStart) {
            newIndex = maxIndex;
          }
        }
      }

      if (newIndex !== this.activeThumbIndex) {
        this.activeThumbIndex = newIndex;
      }
    },

    onChangeActiveSlide(index) {
      if (this.$refs.videos) this.onPauseVideo();
      this.activeIndex = index;
      this.activeThumbIndex = index;
    },

    onChangeSlide(direction) {
      if (this.$refs.videos) this.onPauseVideo();
      if (direction === 'prev') {
        if (this.activeIndex > 0) {
          this.onChangeActiveSlide(this.activeIndex - 1);
        }
      } else if (direction === 'next') {
        if (this.activeIndex < this.slides.length - 1) {
          this.onChangeActiveSlide(this.activeIndex + 1);
        }
      }
    },

    //--video
    onVideoEnded() {
      this.isVideoEnded = true;
    },

    onVideoPlaying() {
      this.isVideoEnded = false;
    },

    onPlayVideo() {
      let videoEl = this.$refs.videos[this.activeIndex];
      if (videoEl && typeof videoEl.play === 'function') {
        videoEl.play();
      }
    },

    onPauseVideo() {
      let videoEl = this.$refs.videos[this.activeIndex] || null;
      if (videoEl && typeof videoEl.pause === 'function') {
        videoEl.pause();
        this.isVideoEnded = true;
      }
    },

    _mouseScroll(event) {
      event.preventDefault();

      if (this.isScrolling) return;
      this.isScrolling = true;

      let deltaY = event.deltaY;

      if (deltaY > 0) {
        this.onChangeSlide('next');
      } else if (deltaY < 0) {
        this.onChangeSlide('prev');
      }

      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
      }, 300);
    },

    _touchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchEndX = this.touchStartX;
    },

    _touchMove(event) {
      this.touchEndX = event.touches[0].clientX;
    },

    _touchEnd() {
      let diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) < this.swipeThreshold) return;

      if (diff > 0) {
        this.onChangeSlide('next');
      } else if (diff < 0) {
        this.onChangeSlide('prev');
      }

      this.touchStartX = 0;
      this.touchEndX = 0;
    }
  },
  beforeDestroy() {
    let sliderMain = this.$refs.zmSliderMain;
    if (sliderMain) {
      sliderMain.removeEventListener('wheel', this._mouseScroll);
      sliderMain.removeEventListener('touchstart', this._touchStart);
      sliderMain.removeEventListener('touchmove', this._touchMove);
      sliderMain.removeEventListener('touchend', this._touchEnd);
    }
  }
};
